/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as createGrant from "./access/createGrant.js";
export * as deleteGrant from "./access/deleteGrant.js";
export * as getStatus from "./access/getStatus.js";
export * as grant from "./access/grant.js";
export * as listGrants from "./access/listGrants.js";
export * as policy from "./access/policy.js";
export * as updatePolicy from "./access/updatePolicy.js";
export * as defs from "./access/defs.js";
